import React from 'react';

const SignInWithStartFinalizeQboPage = React.lazy(
    () =>
        import(
            /* webpackChunkName: "sign-in-with-start-finalize-qbo-page" */ './pages/SignInWithStartFinalizeQboPage/SignInWithStartFinalizeQboPage'
        )
);

export default [
    {
        path: '/oauth2/startFinalizeQbo',
        component: SignInWithStartFinalizeQboPage,
    },
];
